import React, { useState, useEffect } from 'react';
import { Card, Button, message, List, Typography } from 'antd';
import api from '../services/api';
import DebugTest from '../components/Debug/DebugTest';

const { Title, Text } = Typography;

const APITest: React.FC = () => {
  const [gameTypes, setGameTypes] = useState<any[]>([]);
  const [nodes, setNodes] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [testResult, setTestResult] = useState<string>('');

  const testAPIs = async () => {
    setLoading(true);
    setTestResult('');
    
    try {
      // 测试游戏类型API
      const gameTypesResponse = await api.get('/games/types');
      setGameTypes(gameTypesResponse.data);
      setTestResult(prev => prev + `✅ 游戏类型API成功: ${gameTypesResponse.data.length}个游戏类型\n`);
      
      // 测试节点API
      const nodesResponse = await api.get('/admin/nodes');
      setNodes(nodesResponse.data);
      setTestResult(prev => prev + `✅ 节点API成功: ${nodesResponse.data.length}个节点\n`);
      
      // 测试创建服务器
      const serverData = {
        name: '调试测试服务器',
        game_type_id: gameTypesResponse.data[0]?.id || 1,
        node_id: nodesResponse.data[0]?.id || 1,
        port: 27017,
        password: '',
        max_players: 20,
        config: {},
        duration_days: 7
      };
      
      const createResponse = await api.post('/servers', serverData);
      setTestResult(prev => prev + `✅ 创建服务器成功: ${createResponse.data.message}\n`);
      
    } catch (error: any) {
      console.error('API测试失败:', error);
      setTestResult(prev => prev + `❌ API测试失败: ${error.response?.data?.message || error.message}\n`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <DebugTest />
      
      <Card>
        <Title level={2}>API调试测试</Title>
        
        <Button 
          type="primary" 
          onClick={testAPIs} 
          loading={loading}
          className="mb-4"
        >
          测试所有API
        </Button>
        
        {testResult && (
          <Card title="测试结果" className="mb-4">
            <pre style={{ whiteSpace: 'pre-wrap' }}>{testResult}</pre>
          </Card>
        )}
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Card title="游戏类型" size="small">
            <List
              size="small"
              dataSource={gameTypes.slice(0, 5)}
              renderItem={(item) => (
                <List.Item>
                  <Text>{item.id}: {item.display_name}</Text>
                </List.Item>
              )}
            />
            {gameTypes.length > 5 && (
              <Text type="secondary">...还有{gameTypes.length - 5}个游戏类型</Text>
            )}
          </Card>
          
          <Card title="节点" size="small">
            <List
              size="small"
              dataSource={nodes}
              renderItem={(item) => (
                <List.Item>
                  <Text>{item.id}: {item.name} ({item.status})</Text>
                </List.Item>
              )}
            />
          </Card>
        </div>
      </Card>
    </div>
  );
};

export default APITest;
